<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/materialsManage/add')">新增</el-button>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">
        <el-form-item label="物料名称" prop="materialName">
          <el-input v-model="searchForm.materialName" clearable placeholder="请输入物料名称"></el-input>

        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="100" label="物料名称" prop="materialName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="物料规格" prop="materialSpec"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" label="物料类型" prop="materialType"></el-table-column>

        <el-table-column fixed="right" label="操作" width="150">
          <template v-slot="{ row }">
            <el-button type="text" @click="$router.push('/materialsManage/detail?materialId=' + row.materialId)">详情</el-button>
            <el-button type="text" v-if="hasEdit" @click="$router.push('/materialsManage/edit?materialId=' + row.materialId)">编辑</el-button>
            <el-button type="text" v-if="hasDel" @click="deleteRow(row.materialId)" class="del-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'materialsManage',

  data() {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        materialName: null

      }

    }
  },
  computed: {

    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.materialsManage.selectYcMaterialByPage, {
        params: {
          page: this.page,
          ...this.searchForm
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch() {
      this.page = 1
      this.loadData()
    },
    resetForm() {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        materialName: null
      }
      this.onSearch()
    },
    deleteRow(materialId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.materialsManage.deleteYcMaterial, {
          materialId
        }).then(() => {
          this.loadData()
        })
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}
</style>
